module.exports = __webpack_public_path__ + "img/17.3d06cb01.png";